import { ICandidateToResourceInstance } from "../../shared/model/candidate-to-resource-instance.model";

export const initialValuesResource: ICandidateToResourceInstance = {};
